


























































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { useFormat, useRouter } from 'vivat';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';

import useAuth from '@/useAuth';

import getCashflow from '@/gql/cashflow/getCashFlow.gql';
import createCashflow from '@/gql/cashflow/createCashflow.gql';
import updateCashflow from '@/gql/cashflow/updateCashflow.gql';

import CommonCheckboxIcon from '@/components/CommonCheckboxIcon.vue';
import CashflowCategoryWithPaymentAccount from '@/components/CashFlow/CashflowCategoryWithPaymentAccount.vue';
import CommonModalWithPreset from '../CommonModalWithPreset.vue';

const CommonFormWithCashFlowEditor = defineComponent({
  components: {
    CommonCheckboxIcon,
    CashflowCategoryWithPaymentAccount,
    CommonModalWithPreset,
  },
  props: {
    edit: { default: false },
    entity: { default: '' },
  },
  setup(props) {
    const { me } = useAuth();
    const { route } = useRouter();
    const NOW = useFormat.date().computerShortDate();
    const cashFlow = reactive({
      type: 'EXPENSE',
      category: {
        cashflowCategory: '',
        paymentAccount: '',
      },
      name: '',
      amount: '0',
      vehicle: '',
      date: NOW,
    });

    const bindWith = computed(() => {
      if (props.edit) return '';
      if (route.value.name === 'CreateVehicleCashflow') return 'vehicle';
      return '';
    });

    const cashFlowInput = computed(() => ({
      id: props.edit ? route.value.params.id : undefined,
      name: cashFlow.name,
      amount: parseFloat(cashFlow.amount),
      type: cashFlow.type,
      createdBy: props.edit ? { connect: me.id } : undefined,
      date: cashFlow.date,
      paymentAccount: { connect: cashFlow.category.paymentAccount },
      [bindWith.value]: bindWith.value !== '' ? { connect: route.value.params.id } : undefined,
      // deliveryNote: { connect: cashFlow },
      // driver: { connect: cashFlow },
      // vehicle: { connect: cashFlow },
      // ============================
      // category: { connect: cashFlow.category.cashflowCategory },
    }));

    const { result: cashflowResult, loading } = useQuery(getCashflow, computed(() => ({
      id: route.value.params.id,
    })), () => ({ fetchPolicy: 'network-only' }));
    const _cashflow = useResult(cashflowResult, {}, (data) => data.cashFlow);
    watch(() => cashflowResult.value, (newVal, oldVal) => {
      if (!loading.value && newVal !== oldVal && props.edit) {
        cashFlow.name = _cashflow.value.name;
        cashFlow.amount = _cashflow.value.amount;
        cashFlow.category.cashflowCategory = _cashflow.value.account.category.id;
        cashFlow.category.paymentAccount = _cashflow.value.account.id || '';
      }
    });

    const refetchQueryList = ['getCashFlows', 'getCashFlowStats'];
    const createCashFlowutation = useMutation(createCashflow, () => ({
      variables: {
        input: cashFlowInput.value,
      },
      refetchQueries: refetchQueryList,
      update: (cache: any) => {
        cache.evict({ id: 'ROOT_QUERY' });
      },
    }));
    const updateCashFlowMutation = useMutation(updateCashflow, () => ({
      variables: {
        input: cashFlowInput.value,
      },
      refetchQueries: refetchQueryList,
      update: (cache: any) => {
        cache.evict({ id: 'ROOT_QUERY' });
      },
    }));
    const confirmModal = ref(null);
    createCashFlowutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    updateCashFlowMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    const errorModal = ref(null);
    createCashFlowutation.onError(() => {
      (errorModal.value as any).compose();
    });
    updateCashFlowMutation.onError(() => {
      (errorModal.value as any).compose();
    });

    const computedMutation = computed(() => {
      if (props.edit) return updateCashFlowMutation;
      return createCashFlowutation;
    });

    return {
      confirmModal,
      errorModal,

      cashFlow,
      computedMutation,

      bindWith,
    };
  },
});

export default CommonFormWithCashFlowEditor;
